export default class Result<T> {
    public value: T;
    public errors: string[];
    public get hasErrors(): boolean {
        return this.errors != null && Array.isArray(this.errors) && this.errors.length > 0;
    }

    /**
     * Returns true if the result is successful.
     */
    public get isSuccess(): boolean {
        return !this.hasErrors;
    }

    /**
     * Returns true if the result is a failure.
     */
    public get isFailure(): boolean {
        return this.hasErrors;
    }

    public get isForbidden(): boolean {
        return this.errors != null 
            && Array.isArray(this.errors) 
            && this.errors.length > 0 
            && this.errors.toString().includes("403");
    }

    constructor(value: T, ...errors: string[]) {
        this.value = value;
        this.errors = errors[0] === undefined || errors[0] == null ? [] : errors;
    }
}